export default __webpack_public_path__ + "static/media/tictactoe.1279be85.png";